export default __webpack_public_path__ + "static/media/Link to URL.8a438082.mp4";